export default __webpack_public_path__ + "static/logo_client_marianos@2x-085256b0a3d3c95fdd455fbbacd08fab.png";